// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"cee15c82","248":"df7b74a4","314":"ab0d6ffc","418":"33f95e99","860":"61f86d41","868":"960c50dd"}[chunkId] + ".chunk.css";
};